<template>
  <MIcon
    :id="`mc-text-input__icon-${id}`"
    class="mc-left-icon-input__icon"
    :name="icon"
  />
</template>

<script>
import MIcon from '../icon/MIcon.vue';
import { useId } from 'vue';

export default {
  name: 'MTextInputIcon',
  components: {
    MIcon,
  },
  props: {
    icon: {
      type: String,
      default: null,
    },
  },
  setup() {
    return {
      id: useId()
    };
  },
};
</script>

<style lang="scss">
@import 'settings-tools/all-settings';
@import 'components/c.left-icon-input';
</style>
